/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class SnapshotServiceApi extends runtime.BaseAPI {
    /**
     * Snapshot triggers a snapshot for the connection.
     */
    async snapshotServiceSnapshotRaw(requestParameters, initOverrides) {
        if (requestParameters['locationOrganizationId'] == null) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter "locationOrganizationId" was null or undefined when calling snapshotServiceSnapshot().');
        }
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling snapshotServiceSnapshot().');
        }
        const queryParameters = {};
        if (requestParameters['locationProjectId'] != null) {
            queryParameters['location.project_id'] = requestParameters['locationProjectId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/connections/{connection_id}/snapshot`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters['locationOrganizationId']))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters['connectionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Snapshot triggers a snapshot for the connection.
     */
    async snapshotServiceSnapshot(locationOrganizationId, connectionId, locationProjectId, initOverrides) {
        const response = await this.snapshotServiceSnapshotRaw({ locationOrganizationId: locationOrganizationId, connectionId: connectionId, locationProjectId: locationProjectId }, initOverrides);
        return await response.value();
    }
}
